import React from "react";
import { useLanguage } from "../../common/hooks/use-language";

function Navbar() {
  const lang = useLanguage();
  return (
    <nav className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x fixed-top">
      <div className="container-fluid content">
        <a className="navbar-brand" href="#">
          <img src="/home1/assets/img/logo.svg" alt="" className="logo" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link" aria-current="page" href="#home">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about">
                About
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#services">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#process">
                Process
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#projects">
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact
              </a>
            </li>
          </ul>
          <div className="nav-side">
            <a
              href="/"
              id="lang-btn-active"
              className="icon ms-3"
              onClick={(e) => {
                e.preventDefault();
                lang.onChangeLang("en");
              }}
            >
              <span> EN </span>
            </a>
            <a
              href="/ar"
              id="lang-btn"
              className="icon ms-3"
              onClick={(e) => {
                e.preventDefault();

                lang.onChangeLang("ar");
              }}
            >
              <span> AR </span>
            </a>
            {/* <a href="#" className="icon ms-5 fsz-21">
              <span>
                <i className="la la-search"></i>{' '}
              </span>
            </a> */}
            {/* <a href="#" className="icon ms-3 side_menu_btn fsz-21">
              <span>
                <i className="la la-grip-lines"></i>{' '}
              </span>
            </a> */}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
